/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneHeader/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneHeader({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneHeader",
  alignItems,
  justifyContent,
  required,
  from,
  size,
  dock,
  focused,
  disabled,
  hovered,
  invalid,
  valid,
  clearFilterOnBlur,
  placeholder,
  value,
  isSelected,
  isMultiChoice,
  onClick,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  onChangeFilter,
  valueFilter,
  onKeyUp,
  isShowingOptions,
  optionsRef,
  inputRef,
  fromCustom,
  onClickAddFilterAsCustomOption,
  isShowingAddFilterAsCustomOption,
  selected,
  isSelectedAll,
  isEmpty,
  onClickToggleAll
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOneHeader.Horizontal"
  data-view-path={viewPath}
 style={{'--ai-1-2AjxP': alignItems,'--jc-2-2AjxP': justifyContent}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 required={required}
 from={from}
 size={size}
 dock={dock}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 clearFilterOnBlur={clearFilterOnBlur}
 placeholder={placeholder}
 value={value}
 isSelected={isSelected}
 isMultiChoice={isMultiChoice}
 onClick={onClick}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 onChangeFilter={onChangeFilter}
 valueFilter={valueFilter}
 onKeyUp={onKeyUp}
 isShowingOptions={isShowingOptions}
 innerRef={optionsRef}
 inputRef={inputRef}
 fromCustom={fromCustom}
 onClickAddFilterAsCustomOption={onClickAddFilterAsCustomOption}
 isShowingAddFilterAsCustomOption={isShowingAddFilterAsCustomOption}
 selected={selected}
 isSelectedAll={isSelectedAll}
 isEmpty={isEmpty}
 onClickToggleAll={onClickToggleAll}
>
{children}
</Children>
</div>
</React.Fragment>)
}